"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeQueryString = void 0;
/**
 * @hidden
 */
function encodeQueryString(queryParameters) {
    var components = [];
    for (var _i = 0, queryParameters_1 = queryParameters; _i < queryParameters_1.length; _i++) {
        var keyValuePair = queryParameters_1[_i];
        var key = keyValuePair[0];
        var value = keyValuePair[1];
        components.push("".concat(key, "=").concat(encodeURIComponent(value)));
    }
    return components.join('&');
}
exports.encodeQueryString = encodeQueryString;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVXJsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2xpYi91dGlscy9VcmwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUE7O0dBRUc7QUFDSCxTQUFnQixpQkFBaUIsQ0FBQyxlQUEyQjtJQUMzRCxJQUFNLFVBQVUsR0FBRyxFQUFFLENBQUM7SUFDdEIsS0FBMkIsVUFBZSxFQUFmLG1DQUFlLEVBQWYsNkJBQWUsRUFBZixJQUFlLEVBQUU7UUFBdkMsSUFBTSxZQUFZLHdCQUFBO1FBQ3JCLElBQU0sR0FBRyxHQUFHLFlBQVksQ0FBQyxDQUFDLENBQUMsQ0FBQztRQUM1QixJQUFNLEtBQUssR0FBRyxZQUFZLENBQUMsQ0FBQyxDQUFDLENBQUM7UUFDOUIsVUFBVSxDQUFDLElBQUksQ0FBQyxVQUFHLEdBQUcsY0FBSSxrQkFBa0IsQ0FBQyxLQUFLLENBQUMsQ0FBRSxDQUFDLENBQUM7S0FDeEQ7SUFDRCxPQUFPLFVBQVUsQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUM7QUFDOUIsQ0FBQztBQVJELDhDQVFDIn0=